<template>
  <b-card>
    <!-- <div id="cover" style="position: fixed; height: 100%; width: 100%; top:0; left: 0; background: rgba(255, 255, 255, 0.8); z-index:9999;">
      <div style="color:white;position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0; width: 200px; height: 30px; border-radius: 3px;">
      <img class="navbar-brand-full" src="/static/img/preload.gif"><br/>
      </div>
    </div> -->
    <b-row>
      <location-card :location='this.location'></location-card>
    </b-row>
    <nav class="navbar navbar-light bg-light justify-content-between" style="margin-bottom: 10px;background-color:rgb(51, 103, 103) !important;">
      <a class="navbar-brand"> </a>
      <form class="form-inline">
        <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search" v-model="searchTerm" :state="searchLocks">
      </form>
    </nav>
    <div v-if="items == undefined">
      <div class="alert alert-danger">
        <ul class="fa-ul" style="margin-bottom: 0px;">
          <li>
            <i class="fa fa-info-circle fa-li"></i>
            No locks found for current location<br/>
            Please assign lock to location Or you can use transfer lock from other location to current location.
          </li>
        </ul>
      </div>
    </div>
    <b-row>
      <b-col sm="6" lg="3" v-for="nextItem in items" v-bind:key="nextItem.id">
        <lock-card :nextItem=nextItem></lock-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import LockCard from '@/views/base/haus/LockCard'
import LocationCard from '@/views/base/haus/LocationCard'

let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API_ASSIGN_LOCK_TO_LOCATION = BASE + '/api/locks/assignLocation'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'authorization': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function filterItems (needle, heystack) {
  var query = needle.toLowerCase()
  return heystack.filter(function (item) {
    let name = item.lockName.toLowerCase().indexOf(query) >= 0
    let alias = item.lockAlias.toLowerCase().indexOf(query) >= 0
    if (name || alias) return true
    else return false
  })
}
export default {
  name: 'all-locks',
  components: {
    LockCard,
    LocationCard
  },
  data: () => {
    return {
      searchTerm: '',
      location: null,
      locationId: null,
      items: [],
      itemsFull: [],
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      filter: null,
      selected: [],
      selectAll: false
    }
  },
  computed: {
    searchLocks () {
      var needle = this.$data.searchTerm
      if (needle.length > 1) {
        filterItems(needle, this.$data.itemsFull).then(dataList => {
          this.$data.items = dataList
        })
      } else {
        this.$data.items = this.$data.itemsFull
      }
      return true
    }
  },
  mounted () {
    let localLocksList = localStorage.getItem('localLocksList')
    this.$data.locationId = localStorage.getItem('locationId')

    if(localLocksList === null || localLocksList === 'undefined') {
      constants.gotoLogin("AllLocks")
    } 
    else {
      //let lockForLocation = localStorage.getItem('locksForLocation')
      this.$data.itemsFull = JSON.parse(localLocksList)
    }

    this.getLocalLocationDetail()
  },
  methods: {
    getLocalLocationDetail() {
      let localLocationsList = localStorage.getItem('localLocationsList')
      let localLocationId = localStorage.getItem('locationId')
      if (localLocationsList == null || localLocationsList == 'undefined') {
        constants.gotoLogin()
      } else {
        localLocationsList = JSON.parse(localLocationsList)
        for (let i in localLocationsList) {
          let loopLocation = localLocationsList[i]
          if (localLocationId == loopLocation.id) {
            this.$data.location = loopLocation
            if (loopLocation.owner.name === null) {
              this.$data.location.owner.name = localStorage.getItem('name')
            }
            return loopLocation
          }
        }
        return null
      }
    },
    getRowCount (items) {
      return items.length
    },
    openlink (link) {
      location.href = link
    }
  },
  assignToLocation (lockId, idx) {
    let parameters = {
      client_id: constants.NEWPORT_CONST.CLIENT_ID,
      client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
      accessToken: localStorage.getItem('token'),
      lockId: lockId,
      locationId: localStorage.getItem('locationId')
    }
    postdata(API_ASSIGN_LOCK_TO_LOCATION, parameters)
      .then(data => {
        console.log(data)
      })
      .catch(error => {
        console.error(error)
      })
    this.$data.items.splice(idx, 1)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/AllLocks.vue